export const SET_SIGNALR_DATA = 'SET_SIGNALR_DATA';
